import ServionWordmark from '@/components/icons/servion/servion-wordmark';
import { Link } from '@inertiajs/react';
import type { OpenWelcomeDialog } from './data';
type Props = { seekTo: (value: number) => void; openDialog: OpenWelcomeDialog };
export function WelcomeFooter({ seekTo, openDialog }: Props) {
    return (
        <footer className="site-footer" id="rodape">
            <div className="site-footer-inner">
                <div className="site-footer-main">
                    <div className="footer-brand">
                        <Link
                            href="#inicio"
                            className="footer-wordmark"
                            data-seek="0"
                            onClick={(event) => {
                                event.preventDefault();
                                seekTo(0);
                            }}
                            aria-label="Servion, voltar ao início"
                        >
                            <ServionWordmark
                                title="Servion"
                                width={140}
                                height={(140 * 193.84) / 1080}
                                primaryColor="#7EDCB1"
                                textColor="var(--srv-welcome-ink)"
                                textOffsetY={0}
                            />
                        </Link>
                        <p>Emissão e organização de NFS-e.</p>
                    </div>
                    <nav className="footer-nav" aria-label="Rodapé">
                        <button
                            type="button"
                            data-seek="1"
                            onClick={(event) => {
                                event.preventDefault();
                                seekTo(1);
                            }}
                        >
                            Produto
                        </button>
                        <button
                            type="button"
                            data-dialog="plans-dialog"
                            onClick={(event) =>
                                openDialog('plans-dialog', event.currentTarget)
                            }
                        >
                            Planos
                        </button>
                        <button
                            type="button"
                            data-dialog="faq-dialog"
                            onClick={(event) =>
                                openDialog('faq-dialog', event.currentTarget)
                            }
                        >
                            Perguntas frequentes
                        </button>
                        <button
                            type="button"
                            data-dialog="support-dialog"
                            onClick={(event) =>
                                openDialog(
                                    'support-dialog',
                                    event.currentTarget,
                                )
                            }
                        >
                            Suporte
                        </button>
                    </nav>
                </div>
                <div className="site-footer-bottom">
                    <p>
                        ©{' '}
                        <span data-current-year>
                            {new Date().getFullYear()}
                        </span>{' '}
                        Servion.
                    </p>
                    <button
                        className="footer-back-top"
                        type="button"
                        data-seek="0"
                        onClick={(event) => {
                            event.preventDefault();
                            seekTo(0);
                        }}
                    >
                        Voltar ao início <span aria-hidden="true">↑</span>
                    </button>
                </div>
            </div>
        </footer>
    );
}
